import { ConfigurationService } from './../../service/configuration.service';
import { AdminPermission, UserPermission } from './../../model/common/nav-item';
import { Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { AuthenticationService } from 'src/app/shared/service/auth.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { Router } from '@angular/router';
import { User } from 'src/app/shared/model/auth/user.model';
import { NavService } from 'src/app/shared/service/nav.service';
import {  NavItem } from 'src/app/shared/model/common/nav-item';
import { SpinnerService } from 'src/app/shared/service/spinner.service';
import { MatDialog } from '@angular/material/dialog';
import { NotificationHubService } from '../../service/notification-hub.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, OnDestroy, AfterViewInit {
  logo = require('../../../../assets/logo/logo.png')
  pdfPath: string = '../../../../assets/Help.pdf'; // Path to the PDF file
  private _mobileQueryListener: () => void;
  mobileQuery: MediaQueryList;
  showSpinner: boolean;
  userName: string = "Admin User";
  appName: string = "App";
  lastLogin: string = "";
  tickerMessage: any = '';
  isLoggedIn: boolean = false;
  selectedValue: number;
  @ViewChild('snav') appDrawer: ElementRef;
  public user: User;
  public notificationData:any;
  public notificationCount=0;
    labelTextSubmittedClosed = "";
  labelTextPending = "";
  labelTextApproved = "";
  labelTextInbox = "";
  labelTextSent = "";
  public userMenuItems: NavItem[] = [];
  navItems: NavItem[] = [
 {
      displayName: 'Dashboard',
      iconName: 'dashboard',
      route: '/dashboard',
      visible: true
    },
    {
      displayName: 'Pending/Approved',
      iconName: 'check_circle',
      visible: true,
      children:[
        {
          displayName: this.labelTextPending,
          iconName: 'hourglass_empty',
          route: '/letter-management/pending',
          visible: true,
            iconColor:'orange'
        },
        {
          displayName: this.labelTextApproved,
          iconName: 'query_builder',
          route: '/letter-management/pending-other',
          visible: true,
        },
        {
          displayName: this.labelTextSubmittedClosed, 
          iconName: 'verified_user',
          route: '/letter-management/submitted-closed',
          visible: true,
          iconColor:'green'

        },
        {
          displayName: 'Cancelled',
          iconName: 'cancel_presentation',
          route: '/letter-management/cancelled',
          visible: true,
          iconColor:'red'

        }
      ]
    },
    {
      displayName: 'Pending/forward',
      iconName: 'forward',
      route: '/letter-management/pending-forward',
      visible: this.isBhawan('')
    },
    {
      displayName: 'My Letters',
      iconName: 'find_in_page',
      route: '/letter-management/list',
      visible: this.isVisible('')
    },
    {
      displayName: 'Received Letters',
      iconName: 'email',
      route: '/letter-management/recieved',
      visible: true
    },
    {
      displayName: 'Maintenance',
      iconName: 'settings',
      visible: this.isBhawan(''),
      children:[
        {
          displayName: 'Units',
          iconName: 'account_balance',
          route: '/admin/units',
          visible: true
        }
     
      ]
    },
  
  ];
  @ViewChild(CdkScrollable) scrollable: CdkScrollable;
  @ViewChild("externalPdfViewer", { static: true }) public externalPdfViewer;
  constructor(private changeDetectorRef: ChangeDetectorRef, private router: Router,
    private media: MediaMatcher,private snackBar: MatSnackBar,
    private navService: NavService,
    private notificationHubService:NotificationHubService,
    private authService: AuthenticationService,private configuration:ConfigurationService, public spinnerService: SpinnerService, public dialog: MatDialog) {

    this.mobileQuery = this.media.matchMedia('(max-width: 1000px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.user = this.authService.currentUser;
    if (this.user == null) {
      this.router.navigate(['/auth'])
    } else {
      this.isLoggedIn = true;
    }
  }

  ngOnInit(): void {
    this.userName =this.user.unit+":" +this.user.postion;
  if (this.authService.isAboveBhavan) {
      this.labelTextSubmittedClosed = "Submitted & Closed";
      this.labelTextPending = "Pending";
      this.labelTextApproved = "Forwarded";
      this.labelTextInbox = "Received Letters";
      this.labelTextSent = "My Letters";
    } else {
      this.labelTextSubmittedClosed = "Letter Outwarded";
      this.labelTextPending = "My Approval Pending";
      this.labelTextApproved = "Awaiting Next Approval";
      this.labelTextInbox = "Received Letters";
      this.labelTextSent = "My Letters";
    }
 this.navItems = this.buildNavItems();
  }

private buildNavItems(): NavItem[] {
  return [
    {
      displayName: 'Dashboard',
      iconName: 'dashboard',
      route: '/dashboard',
      visible: true
    },
    {
      displayName: 'Pending/Approved',
      iconName: 'check_circle',
      visible: true,
      children:[
        {
          displayName: this.labelTextPending,
          iconName: 'hourglass_empty',
          route: '/letter-management/pending',
          visible: true,
          iconColor:'orange'
        },
        {
          displayName: this.labelTextApproved,
          iconName: 'query_builder',
          route: '/letter-management/pending-other',
          visible: true,
        },
        {
          displayName: this.labelTextSubmittedClosed, 
          iconName: 'verified_user',
          route: '/letter-management/submitted-closed',
          visible: true,
          iconColor:'green'
        },
        {
          displayName: 'Cancelled',
          iconName: 'cancel_presentation',
          route: '/letter-management/cancelled',
          visible: true,
          iconColor:'red'
        }
      ]
    },
    {
      displayName: 'Pending/forward',
      iconName: 'forward',
      route: '/letter-management/pending-forward',
      visible: this.isBhawan('')
    },
    {
      displayName: 'My Letters',
      iconName: 'find_in_page',
      route: '/letter-management/list',
      visible: this.isVisible('')
    },
    {
      displayName: 'Received Letters',
      iconName: 'email',
      route: '/letter-management/recieved',
      visible: true
    },
    {
      displayName: 'Maintenance',
      iconName: 'settings',
      visible: this.isBhawan(''),
      children:[
        {
          displayName: 'Units',
          iconName: 'account_balance',
          route: '/admin/units',
          visible: true
        }
      ]
    },
  ];
}
  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  ngAfterViewInit(): void {
    this.navService.appDrawer = this.appDrawer;
    this.changeDetectorRef.detectChanges();
  }
  logout() {
    this.authService.logout();
  }
  isVisible(menuName): boolean {
  if (this.authService.isAllowCreate) {
      return true
    }else{
      return false;
    }
    
  }
  isBhawan(menuName): boolean {
    if (this.authService.currentUser.IsBhavan) {
        return true
      }else{
        return false;
      }
      
    }
  help(){
    window.open(this.pdfPath, '_blank');
  }
  
  clearNotification(){
    this.spinnerService.start();
    this.notificationHubService.downloadFile( "../assets/help.pdf").subscribe((res)=>{
      this.externalPdfViewer.pdfSrc =res;
   
    this.externalPdfViewer.refresh();
    })
  }
  notificationClick(item:any){
    this.deleteNotification(item.id);
    this.router.navigate([item.url]);
  }

  deleteNotification(id){
    this.notificationHubService.deleteNotifications(id).subscribe(()=>{
      this.spinnerService.stop();
    })
  }
  onCloseNotification(){
    this.notificationCount=0;
  }
}
